define('QuoteToSalesOrderWizard.Module.Confirmation.Extension', [
  'RequestQuoteWizard.Module.Confirmation',

  'Backbone',
  'jQuery',
  'Utils',
  'underscore'
], function (
  RequestQuoteWizardModuleConfirmation,

  Backbone,
  jQuery,
  Utils,
  _
) {
  'use strict';

  _.extend(RequestQuoteWizardModuleConfirmation.prototype, {
    getContext: _.wrap(RequestQuoteWizardModuleConfirmation.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      var conf = this.model.get('confirmation');
      var rep = conf.get('salesrep');

      context.salesrepPhone = rep.phone;
      context.salesrepEmail = rep.email;
      context.hasSalesrep = !!rep;

      return context;
    })
  });
});
